import React from 'react';

const Advantages = () => {
  const advantages = [
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'GDPR-Nativo',
      description: 'Plataforma con cumplimiento total de protección de datos desde el diseño.'
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
          <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      title: 'Especialización',
      description: '19 años de experiencia en IA y biometría aplicada a retail, turismo y hostelería.'
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.7 6.3C15.1 5.9 15.1 5.3 14.7 4.9L12.7 2.9C12.3 2.5 11.7 2.5 11.3 2.9L9.3 4.9C8.9 5.3 8.9 5.9 9.3 6.3L11.3 8.3C11.7 8.7 12.3 8.7 12.7 8.3L14.7 6.3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8 12L16 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M8 16L16 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M8 20L12 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: 'Tecnología Propia',
      description: 'Plataforma desarrollada íntegramente por nuestro equipo. Sin dependencias de terceros.'
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 3V21H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M7 16L12 11L16 15L21 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M21 10V3H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Analítica Avanzada',
      description: 'Transforma cada conversación en insights valiosos. Mejora continua garantizada.'
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Implementación Rápida',
      description: 'De la firma al despliegue en semanas, no meses. Mínima intervención técnica.'
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2V22M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'ROI Medible',
      description: 'Reducción de costes + mejora de satisfacción + insights = retorno demostrable.'
    }
  ];

  return (
    <section className="section" id="ventajas">
      <div className="section-header">
        <div className="section-tag">Ventajas competitivas</div>
        <h2 className="section-title">¿Por qué elegir Myntar?</h2>
        <p className="section-subtitle">
          Combinamos experiencia, tecnología propia y cumplimiento normativo europeo.
        </p>
      </div>
      <div className="grid-3">
        {advantages.map((advantage, index) => (
          <div key={index} className="advantage-card">
            <span className="advantage-icon">{advantage.icon}</span>
            <h3 className="advantage-title">{advantage.title}</h3>
            <p className="advantage-description">{advantage.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Advantages;
